import { render } from "./UserProfileEdit.vue?vue&type=template&id=2fc0dff8&scoped=true"
import script from "./UserProfileEdit.vue?vue&type=script&lang=js"
export * from "./UserProfileEdit.vue?vue&type=script&lang=js"

import "./UserProfileEdit.vue?vue&type=style&index=0&id=2fc0dff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc0dff8"]])

export default __exports__